import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bulma/css/bulma.css'; // Import Bulma CSS
import './assets/styles/main.scss'; // If you have custom styles

const app = createApp(App);
app.use(router);
app.use(store);
app.mount('#app');